import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: ((navigate: NavigateFunction) => void) | null = null;
let navigateRejecter: ((reason?: Error) => void) | null = null;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve, reject) => {
  navigateResolver = resolve;
  navigateRejecter = reject;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    
    if (navigateResolver) {
      navigateResolver(navigate);
      navigateResolver = null;
    }
    
    return () => {
      // Cleanup: reject promise if component unmounts before resolution
      if (navigateRejecter) {
        navigateRejecter(new Error('Router unmounted before navigation was ready'));
        navigateRejecter = null;
      }
    };
  }, [navigate]);
  
  return element;
}
